import { NavItemEnum } from '../../../constants/routing/NavItems';
import { UseCases, useCasesQueryParamKey } from './useCaseConstants';
export const getUseCasesByPage = page => {
  switch (page) {
    case NavItemEnum.MARKETING:
    case NavItemEnum.CONTENT:
    case NavItemEnum.MARKETING_PLUS:
      return [UseCases.MARKETING];
    case NavItemEnum.SALES:
    case NavItemEnum.COMMERCE:
      return [UseCases.SALES];
    case NavItemEnum.SERVICE:
      return [UseCases.SERVICE];
    case NavItemEnum.FREE:
    case NavItemEnum.SMART_CRM:
    case NavItemEnum.DATA:
      return [UseCases.SMART_CRM];
    case NavItemEnum.SUITE:
      return [UseCases.MARKETING, UseCases.SALES, UseCases.SERVICE, UseCases.SMART_CRM];
    case NavItemEnum.HUBSPOT_CREDITS:
    case NavItemEnum.BUNDLE:
    default:
      return [UseCases.MARKETING];
  }
};
export const getValidUniqueUseCasesParams = (searchParams, availableUseCases) => {
  const search = typeof searchParams === 'string' ? new URLSearchParams(searchParams) : searchParams;
  const useCases = search.getAll(useCasesQueryParamKey);

  // Validation
  const validUseCases = useCases.filter(useCase => availableUseCases.includes(useCase));
  const validAndUniqueUseCases = new Set(validUseCases);
  const wasModified = validAndUniqueUseCases.size !== useCases.length;

  // Create new search params
  search.delete(useCasesQueryParamKey);
  for (const useCase of validAndUniqueUseCases) {
    search.append(useCasesQueryParamKey, useCase);
  }
  return {
    wasModified,
    search: search.toString(),
    useCases: Array.from(validAndUniqueUseCases)
  };
};